import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { COMPONENT_LIST_INIT_SORT } from "../constants";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
/** Initial state for behaviour table filter */
export const initFilter = {
    category: "ALL",
    description: "",
    prevalence: [],
};
/** Initial state for behaviour table sort */
export const initSort = {
    property: "component_count",
    reverse: true,
};
/** Initial state for behaviour table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
};
const behaviorSlice = createSlice({
    name: "behavior",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].pagination =
                    action.payload.pagination;
            }
        },
        expandedRowSortUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].sortBy = action.payload.sort;
                state.expandedRows[action.payload.id].pagination.currentPage = 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "behavior");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
    },
});
export const behaviorReducer = behaviorSlice.reducer;
export const { filterUpdated, sortUpdated, paginationUpdated, expandedRowsUpdated, expandedRowPaginationUpdated, expandedRowSortUpdated, focusedRowUpdated, } = behaviorSlice.actions;
export const selectFilter = (state) => state.report.behavior.filter;
export const selectSort = (state) => state.report.behavior.sort;
export const selectPagination = (state) => state.report.behavior.pagination;
export const selectExpandedRow = (state, id) => state.report.behavior.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => { var _a, _b; return (_b = (_a = state.report.behavior.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.pagination) !== null && _b !== void 0 ? _b : initPagination; };
export const selectExpandedRowSort = (state, id) => { var _a, _b; return (_b = (_a = state.report.behavior.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.sortBy) !== null && _b !== void 0 ? _b : COMPONENT_LIST_INIT_SORT; };
export const selectFocusedRow = (state) => state.report.behavior.focusedRow;
export * as default from "./behaviorSlice";
//# sourceMappingURL=behaviorSlice.js.map